import * as React from "react";
import { FunctionComponent, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getCompletedLessons, hideTutorialBanner, LESSON_RULES, Theme } from "@mancala/core";
import AppHeader from "../components/headerbar/AppHeader";
import PageContainer from "../components/PageContainer";
import { Context } from "../context/context";
import PracticeGameCard from "../components/PracticeGameCard";

// The lessons in order, the ones done marked (docs/specs/tutorial, R2.6).
const LearnPage: FunctionComponent<{ context: Context, theme: Theme }> = ({ context }) => {
    const { t } = useTranslation();
    useEffect(() => hideTutorialBanner(context.storage), []);
    const completed = getCompletedLessons(context.storage);
    return (
        <PageContainer>
            <AppHeader context={context} />
            <main className="wrap learn">
                <h1>{t("LearnMangala")}</h1>
                <ol className="lessons">
                    {LESSON_RULES.map((rule, index) => {
                        const done = completed.includes(rule.id);
                        return (
                            <li key={rule.id}>
                                <Link className={"lesson-link panel" + (done ? " done" : "")} to={`/learn/${rule.id}`}>
                                    <span className="num">{done ? "✓" : index + 1}</span>
                                    <span className="name">{t(rule.titleKey)}</span>
                                    {done && <span className="pill">{t("LessonDone")}</span>}
                                </Link>
                            </li>
                        );
                    })}
                </ol>
                <PracticeGameCard context={context} />
                <Link className="rules-link" to="/rules">{t("HowToPlay")}</Link>
            </main>
            <style jsx>{`
                .learn {
                    max-width: 760px;
                    width: 100%;
                    box-sizing: border-box;
                    align-self: center;
                }
                h1 {
                    margin: 0;
                    font-size: 30px;
                    letter-spacing: -.02em;
                }
                .lessons {
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                }
                .learn :global(.lesson-link) {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    padding: 14px 18px;
                    color: var(--ink);
                    text-decoration: none;
                    font-weight: 700;
                }
                .learn :global(.lesson-link:hover) {
                    background: var(--surface2);
                }
                .learn :global(.num) {
                    width: 32px;
                    height: 32px;
                    flex: none;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: var(--surface2);
                }
                .learn :global(.done .num) {
                    background: var(--accent);
                    color: var(--onAccent);
                }
                .learn :global(.name) {
                    flex: 1;
                }
                .learn :global(.rules-link) {
                    color: var(--muted);
                    font-weight: 700;
                }
            `}</style>
        </PageContainer>
    );
};

export default LearnPage;
